(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("1yGYc", function(module, exports) {
const $122a4c5fc2709739$var$counterElements = document.querySelectorAll(".c-counter:not(.--link)");
$122a4c5fc2709739$var$counterElements.forEach((counter)=>{
    const minus = counter.querySelector(".c-counter__button.--minus");
    const plus = counter.querySelector(".c-counter__button.--plus");
    const input = counter.querySelector(".c-counter__input");
    const valueVisual = counter.querySelector(".c-counter__value");
    if (!input) return;
    const handleVisual = ()=>{
        if (valueVisual) valueVisual.innerHTML = input.value ?? "";
    };
    plus?.addEventListener("click", ()=>{
        if (input.max !== input.value) {
            input.stepUp();
            input.dispatchEvent(new Event("change"));
            input.dispatchEvent(new Event("stepUp"));
        }
        handleVisual();
    });
    minus?.addEventListener("click", ()=>{
        if (input.min < input.value) {
            input.stepDown();
            input.dispatchEvent(new Event("change"));
            input.dispatchEvent(new Event("stepDown"));
        }
        handleVisual();
    });
    input.addEventListener("updateVisuals", ()=>{
        handleVisual();
    });
});

});

})();
//# sourceMappingURL=counter.82908f4c.js.map
